import { request } from '@h3/request';
import { H3 } from '@h3/types';

/** 获取高德地图数据 */
export const getAMapInfo = () =>
    request<H3.Http.Response.H3Response<Record<string, string>>>('/v1/address/key', {
        method: 'get',
    });
